import { AclEntriesTooltipBaseEntitiesConfig } from 'common/types/TypeDefs';
import { AclEntriesPage } from 'features/aclEntries/aclEntriesTypeDefs';

export const USER_ACL_ENTRIES_STATUS_TOOLTIP_ENTITIES: AclEntriesTooltipBaseEntitiesConfig[] = [
    {
        entityName: 'User',
        title: 'User membership dates',
        testId: 'user-dates',
        inactiveTestId: 'user-inactive',
        inactiveReasonMessage: 'Inactive due to user membership dates'
    },
    {
        entityName: 'License',
        title: 'License active dates',
        testId: 'license-dates',
        inactiveTestId: 'license-inactive',
        inactiveReasonMessage: 'Inactive due to license dates'
    },
    {
        entityName: 'Acl',
        title: 'Acl active dates',
        testId: 'acl-dates',
        inactiveTestId: 'acl-inactive',
        inactiveReasonMessage: 'Inactive due to ACL dates'
    }
];

export const USERGROUP_ACL_ENTRIES_STATUS_TOOLTIP_ENTITIES: AclEntriesTooltipBaseEntitiesConfig[] = [
    {
        entityName: 'License',
        title: 'License active dates',
        testId: 'license-dates',
        inactiveTestId: 'license-inactive',
        inactiveReasonMessage: 'Inactive due to license dates'
    },
    {
        entityName: 'Acl',
        title: 'Acl active dates',
        testId: 'acl-dates',
        inactiveTestId: 'acl-inactive',
        inactiveReasonMessage: 'Inactive due to ACL dates'
    }
];

export const ACL_ACL_ENTRIES_STATUS_TOOLTIP_ENTITIES_BY_PAGE:
    Partial<Record<
        AclEntriesPage,
        typeof USER_ACL_ENTRIES_STATUS_TOOLTIP_ENTITIES |
        typeof USERGROUP_ACL_ENTRIES_STATUS_TOOLTIP_ENTITIES
    >>
 = {
     [AclEntriesPage.TenantUser]: USER_ACL_ENTRIES_STATUS_TOOLTIP_ENTITIES,
     [AclEntriesPage.UserProfile]: USER_ACL_ENTRIES_STATUS_TOOLTIP_ENTITIES,
     [AclEntriesPage.TenantUserGroup]: USERGROUP_ACL_ENTRIES_STATUS_TOOLTIP_ENTITIES
 };
